import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  button: {
    borderRadius: '10px',
    textTransform: 'capitalize',
    transition: 'background-color 0.15s linear',
    display: 'flex',
    gap: theme.spacing(1),
  },
}));
